<template>
  <div class="container-table-striped">
    <div class="table-hover">
      <table class="table content-table-striped table-striped mb-5">
        <thead>
          <tr class="row global-thead-dark thead-property pl-1">
            <th class="col-md-1" />
            <th class="col text-left ml-n4">
              Servicio
            </th>
            <th class="col">
              Disciplina
            </th>
            <th class="col mr-n5">
              Estatus
            </th>
            <th class="col text-center">
              Aceptada
            </th>
            <th class="col text-center ml-2 mr-n3">
              ¿Determina?
            </th>
            <th class="col" />
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="'ev' + index" class="row">
            <td class="col-md-1">
              <div class="input-group">
                <input
                  :id="'chk' + item.id"
                  v-model="item.checked"
                  type="checkbox"
                  class="option-input checkbox"
                  :checked="item.checked"
                  :disabled="disabled"
                />
                <label :for="'chk' + item.id" class="checkbox-label pl-3 pr-4">
                  <span v-if="item.checked != null">
                    <i class="ic-check" />
                  </span>
                </label>
              </div>
            </td>
            <td class="col">
              {{ item.service }}
            </td>
            <td class="col ml-n4">
              {{ item.discipline }}
            </td>
            <td class="col ml-n4">
              {{ item.status }}
            </td>
            <td class="col">
              <div class="input-group">
                <input
                  :id="'rbacceptedYes' + item.id"
                  type="radio"
                  class="hidden"
                  :name="'rbaccepted' + item.id"
                  :value="true"
                  :disabled="disabled"
                  @change="item.accepted = true"
                />
                <label class="entry" :for="'rbacceptedYes' + item.id">
                  <div class="circle" />
                  <div class="entry-label">Sí</div>
                </label>
                <input
                  :id="'rbacceptedNo' + item.id"
                  type="radio"
                  class="hidden"
                  :name="'rbaccepted' + item.id"
                  :value="false"
                  :disabled="disabled"
                  @change="item.accepted = false"
                />
                <label class="entry" :for="'rbacceptedNo' + item.id">
                  <div class="circle" />
                  <div class="entry-label">No</div>
                </label>
                <div class="highlight" />
              </div>
            </td>
            <td class="col mr-n2">
              <div class="input-group">
                <input
                  :id="'rbadetermineYes' + item.id"
                  type="radio"
                  class="hidden"
                  :name="'rbdetermine' + item.id"
                  :value="true"
                  :disabled="disabled"
                  @change="item.determine = true"
                />
                <label class="entry" :for="'rbrbdetermineYes' + item.id">
                  <div class="circle" />
                  <div class="entry-label">Sí</div>
                </label>
                <input
                  :id="'rbrbdetermineNo' + item.id"
                  type="radio"
                  class="hidden"
                  :name="'rbrbdetermine' + item.id"
                  :value="false"
                  :disabled="disabled"
                  @change="item.determine = false"
                />
                <label class="entry" :for="'rbrbdetermineNo' + item.id">
                  <div class="circle" />
                  <div class="entry-label">No</div>
                </label>
                <div class="highlight" />
              </div>
            </td>
            <td class="mr-3">
              <div class="dropdown">
                <button
                  id="dropdownMenuButton"
                  class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  :disabled="disabled"
                >
                  Acciones
                </button>
                <div
                  class="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                  :disabled="disabled"
                >
                  <a class="dropdown-item" href="#">
                    <i class="fas fa-edit text-green" />
                    Editar
                  </a>
                  <a
                    class="dropdown-item cursor-pointer"
                    @click="deleteItem(index)"
                  >
                    <i class="fas fa-times-circle text-red" />
                    Eliminar
                  </a>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-right">
        <ActionButton
          v-if="!disabled"
          class="btn btn-success success mr-3"
          i="fas fa-file-edit"
          type="button"
        >
          Modificar
        </ActionButton>

        <ActionButton
          v-if="!disabled"
          class="btn btn-success success"
          i="fas fa-file-plus"
          type="button"
        >
          Añadir
        </ActionButton>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/component/checkbox.css';
import { ActionButton } from '@/components/common';
export default {
  name: 'EvaluationOfInformation',
  data() {
    return {
      items: [
        /*{
          id: 1,
          checked: false,
          service: "Adicional",
          discipline: "Audiología / Auditiva / Audiométrica (Audiólogo)",
          status: "Previa",
          accepted: null,
          determine: null
        },
        {
          id: 2,
          checked: false,
          service: "Adicional",
          discipline: "Pediátrica",
          status: "Previa",
          accepted: null,
          determine: null
        },
        {
          id: 3,
          checked: false,
          service: "Adicional",
          discipline: "Pediátrica",
          status: "Previa",
          accepted: null,
          determine: null
        }*/
      ],
    };
  },
  methods: {
    deleteItem(index) {
      this.items.splice(index, 1);
    },
  },
  props: {
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    ActionButton,
  },
};
</script>

<style scoped src="@/assets/css/component/radio-button.css" />
<style scoped>
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}
</style>
